import { fetchApiJson } from "@utils/request";

import { PromotionCodeDTO } from "@features/quotes-funnel/domain/promotion-code";

export async function validatePromotionCode(body: string): Promise<PromotionCodeDTO> {
  return await fetchApiJson(`${process.env.GATSBY_API_BASE}/billing/promotion_codes/validate/`, {
    body,
    method: "POST",
  });
}
